var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCvBack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 117,
    height: 127,
    viewBox: "0 0 117 127",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.5 114.8L112 61.2996L58.5 7.79956L5 61.2996L58.5 114.8Z",
    fill: "#8C0E05",
    stroke: "#DE352B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.8425 46.32C51.6425 46.32 53.8825 47.1467 55.5625 48.8C57.2692 50.4267 58.1225 52.88 58.1225 56.16H53.2825C53.2825 54.2667 52.8825 52.8267 52.0825 51.84C51.2825 50.8533 50.2025 50.36 48.8425 50.36C47.1092 50.36 45.8158 51.0667 44.9625 52.48C44.1092 53.8933 43.6825 55.8933 43.6825 58.48V60.32C43.6825 62.9067 44.1225 64.9067 45.0025 66.32C45.9092 67.7067 47.2425 68.4 49.0025 68.4C50.4158 68.4 51.5225 67.92 52.3225 66.96C53.1225 65.9733 53.5225 64.5333 53.5225 62.64H58.1225C58.1225 65.84 57.2692 68.28 55.5625 69.96C53.8825 71.6133 51.6425 72.44 48.8425 72.44C45.6158 72.44 43.1358 71.36 41.4025 69.2C39.6692 67.0133 38.8025 63.7467 38.8025 59.4C38.8025 55.0267 39.6692 51.76 41.4025 49.6C43.1358 47.4133 45.6158 46.32 48.8425 46.32ZM59.3203 46.8H64.2003L69.4803 64.84H69.6403L74.8403 46.8H79.4403L71.7603 72H67.0003L59.3203 46.8Z",
    fill: "#DE352B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCvBack);
export default __webpack_public_path__ + "static/media/cv-back.766045b147e564abc61b536e625065fd.svg";
export { ForwardRef as ReactComponent };